import { ProductDto } from "../infra/fetchProducts.api";

export const makeCustomProductsCsv = (products: ProductDto[]) => {
  const separator = ";";
  const csvData = [["id", "name", "price", "type"].join(separator)];
  const rows = products.map((product) => {
    return [product.id, product.name, product.price, product.type].join(separator);
  });

  return csvData.concat(rows);
};
